// src/useTikTokPixel.js
import { useEffect } from 'react';
import { loadWhenIdle } from './utils/loadWhenIdle';

/**
 * React hook that injects and initialises the TikTok Pixel
 * **after** the first paint, so it never blocks LCP or INP.
 *
 * @param {string} pixelId – Your TikTok Pixel ID (e.g. 'D7F51PJC77U3RPGVH32G')
 */
const useTikTokPixel = (pixelId) => {
  useEffect(() => {
    // Don't run if no ID or the pixel is already present
    if (!pixelId || window.ttq) return;

    loadWhenIdle(() => {
      /* --- Standard TikTok Pixel bootstrap (unchanged from official snippet) --- */
      (function(w, d, t) {
        w.TiktokAnalyticsObject = t;
        var ttq = w[t] = w[t] || [];
        ttq.methods = [
          'page', 'track', 'identify', 'instances', 'debug', 'on', 'off',
          'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie',
          'holdConsent', 'revokeConsent', 'grantConsent'
        ];
        ttq.setAndDefer = function(t, e) {
          t[e] = function() { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); };
        };
        for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
        ttq.instance = function(t) {
          for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
          return e;
        };
        ttq.load = function(e, n) {
          var r = 'https://analytics.tiktok.com/i18n/pixel/events.js';
          ttq._i = ttq._i || {};
          ttq._i[e] = [];
          ttq._i[e]._u = r;
          ttq._t = ttq._t || {};
          ttq._t[e] = +new Date();
          ttq._o = ttq._o || {};
          ttq._o[e] = n || {};
          var s = document.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = r + '?sdkid=' + e + '&lib=' + t;
          var x = document.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };

        ttq.load(pixelId);
        ttq.page();
      })(window, document, 'ttq');
    });
  }, [pixelId]);
};

export default useTikTokPixel;
